import { DefaultContainedButton, DefaultOutlinedButton } from '@/components/buttons';
import { FormsActions } from '@/store/forms';
import { Card, Stack, Typography } from '@mui/material';
import React from 'react';
import { useDispatch } from 'react-redux';
export const GetPackage = ({ toggleCheckout }) => {
    const dispatch = useDispatch();
    return (React.createElement(Card, { sx: {
            p: 3,
            height: '100%',
            display: 'flex',
            borderRadius: '16px',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
            backgroundColor: 'primary.light',
        } },
        React.createElement(Typography, { mb: 1, textAlign: "center", color: "secondary", fontSize: "1.2rem", fontWeight: 600 }, "Grant catalyst package"),
        React.createElement(Typography, { textAlign: "center", color: "secondary.light", fontSize: "0.875rem", fontWeight: 500 }, "Your personalized grant matches are ready. Get instant access to funding opportunities worth millions."),
        React.createElement(Stack, { my: 3, direction: "row", alignItems: "flex-end", spacing: 0.4 },
            React.createElement(Typography, { lineHeight: 1, fontWeight: 600, color: "primary.dark", fontSize: { xs: '3rem', sm: '4.625rem' } }, "$200"),
            React.createElement(Typography, { color: "secondary", fontSize: "0.875rem", fontWeight: 500, lineHeight: 2 }, "/one time payment")),
        React.createElement(Stack, { mt: 2, direction: "row", alignItems: "center", gap: 2 },
            React.createElement(DefaultOutlinedButton, { title: "Go back", onClick: () => dispatch(FormsActions.setValue({ id: 'steps', step: 2 })) }),
            React.createElement(DefaultContainedButton, { type: "submit", title: "Get this package", onClick: () => toggleCheckout(true) }))));
};
